/* A36 page loading bar (CSS: snippets/twh-nav-progress.liquid). Starts on a plain same-origin
   link click or a GET search submit that nothing else handled (defaultPrevented is read after
   every listener has run). Shows after 150 ms at 30%, then eases toward 85%; 100% only on
   pageswap; hides itself after 15 s (cancelled navigation, download). mailto:, tel:,
   javascript: and SVG links fail the origin check. */
(function (L, later) {
	var bar, st, timer, w, n;

	function set(v) {
		w = v;
		st.transform = 'scaleX(' + v + ')';
	}

	// w is 0 while hidden. Stop the timers and jump (no animation) to hidden, or to full with on = 1.
	function reset(on) {
		clearInterval(timer); // also clears the 150 ms timeout (one id pool)
		if (st) {
			st.transition = 'none';
			st.opacity = on | 0;
			set(on | 0);
		}
	}

	function start(e) {
		later(function () {
			if (e.defaultPrevented) return;
			reset();
			n = 0;
			timer = later(function () {
				if (!st) {
					bar = document.body;
					bar.insertAdjacentHTML('beforeend', '<div class="twh-np" aria-hidden="true"></div>');
					bar = bar.lastChild;
					st = bar.style;
				}
				st.opacity = 1;
				bar.offsetWidth;
				st.transition = '';
				set(0.3);
				// 33 steps of 450 ms + the 150 ms wait = 15 s
				timer = setInterval(function () { ++n > 32 ? reset() : set(0.2975 + 0.65 * w); }, 450); // closes 35% of the gap to 85%
			}, 150);
		});
	}

	addEventListener('click', function (e) {
		var a = e.target.closest('a[href]');
		if (a && !e.button && !(e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) && /^(_self)?$/.test(a.target) &&
			!a.hasAttribute('download') && a.origin == L.origin && !(a.hash && a.pathname == L.pathname && a.search == L.search)) start(e);
	});

	addEventListener('submit', function (e) {
		var f = e.target, u = new URL(f.action);
		if (f.method == 'get' && u.origin == L.origin && /\/search$/.test(u.pathname)) start(e);
	});

	addEventListener('pageswap', function () {
		if (w) reset(1);
	});

	addEventListener('pageshow', function (e) {
		if (e.persisted) reset();
	});
})(location, setTimeout);
